import React from 'react'
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import PropTypes from 'prop-types';
import Spinner from 'Common/Spinner';
const buttonStyles = {
    filled: {
        primary: "bg-primary text-white hover:bg-primaryDark border border-primary hover:border-primaryDark shadow-[0_4px_9px_-4px_#cbcbcb]",
        secondary: "bg-primaryLightColor text-secondaryLight hover:text-textColor border border-primaryLightColor shadow-2",
        tertiary: "bg-gridHeader text-white hover:bg-gridHeader/90 border border-gridHeader hover:border-gridHeader/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        info: "bg-trucare-azure text-white hover:bg-trucare-azure/90 border border-trucare-azure hover:border-trucare-azure/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        success: "bg-trucare-teal text-white hover:bg-trucare-teal/90 border border-trucare-teal hover:border-trucare-teal/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        warning: "bg-trucare-aqua text-trucare-obsidian hover:bg-trucare-aqua/90 border border-trucare-aqua hover:border-trucare-aqua/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        danger: "bg-trucare-nocturne text-white hover:bg-trucare-nocturne/90 border border-trucare-nocturne hover:border-trucare-nocturne/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        light: "bg-trucare-white text-trucare-obsidian hover:bg-primaryLightColor hover:text-trucare-obsidian border border-trucare-white hover:border-primaryLightColor shadow-[0_4px_9px_-4px_#cbcbcb]",
        dark: "bg-trucare-obsidian text-white hover:bg-trucare-obsidian/90 border border-trucare-obsidian shadow-[0_4px_9px_-4px_#cbcbcb]",
    },

    outline: {
        primary: "bg-transparent text-primary border border-primary hover:bg-primaryLightColorTwo shadow-2",
        secondary: "bg-transparent text-secondaryLight hover:text-textColor border border-primaryLightColor shadow-1",
        tertiary: "bg-transparent text-secondaryLight hover:text-textColor border border-primaryLightColor hover:border-gridHeader/90 shadow-2",
        info: "bg-transparent text-trucare-azure border border-trucare-azure hover:bg-trucare-azure/10 hover:border-trucare-mariner/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        success: "bg-transparent text-trucare-teal border border-trucare-teal hover:bg-trucare-aqua/20 hover:border-trucare-abyss/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        warning: "bg-transparent text-trucare-aqua border border-trucare-aqua hover:bg-trucare-aqua/10 hover:border-trucare-aqua/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        danger: "bg-transparent text-trucare-nocturne border border-trucare-nocturne hover:bg-trucare-nocturne/10 hover:border-trucare-nocturne/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        light: "bg-transparent text-trucare-obsidian border border-trucare-white hover:border-primaryLightColor shadow-[0_4px_9px_-4px_#cbcbcb]",
        dark: "bg-transparent text-trucare-obsidian border border-trucare-obsidian hover:bg-primaryLightColor shadow-[0_4px_9px_-4px_#cbcbcb]",
    },

    gradient: {
        primary: "bg-gradient-to-br from-primary to-primaryDark hover:from-primaryDark hover:to-primary text-white hover:text-white border border-primary hover:border-primaryDark shadow-[0_4px_9px_-4px_#cbcbcb]",
        secondary: "bg-gradient-to-br from-secondaryColor to-secondaryColor/70 hover:bg-gradient-to-br/90 text-white hover:text-white border border-secondaryColor hover:border-secondaryColor/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        tertiary: "bg-gradient-to-br from-gridHeader to-gridHeader/70 hover:bg-gradient-to-br/90 text-white hover:text-white border border-gridHeader hover:border-gridHeader/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        info: "bg-gradient-to-br from-trucare-azure to-trucare-azure/70 hover:bg-gradient-to-br/90 text-white hover:text-white border border-trucare-azure hover:border-trucare-azure/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        success: "bg-gradient-to-br from-trucare-teal to-trucare-teal/70 hover:bg-gradient-to-br/90 text-white hover:text-white border border-trucare-teal hover:border-trucare-teal/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        warning: "bg-gradient-to-br from-trucare-aqua to-trucare-aqua/70 hover:bg-gradient-to-br/90 text-trucare-obsidian hover:text-trucare-obsidian border border-trucare-aqua hover:border-trucare-aqua/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        danger: "bg-gradient-to-br from-trucare-nocturne to-trucare-nocturne/70 hover:bg-gradient-to-br/90 text-white hover:text-white border border-trucare-nocturne hover:border-trucare-nocturne/90 shadow-[0_4px_9px_-4px_#cbcbcb]",
        light: "bg-gradient-to-r from-trucare-white to-primaryLightColor hover:bg-gradient-to-r/90 text-trucare-obsidian hover:text-trucare-obsidian border border-trucare-white hover:border-primaryLightColor shadow-[0_4px_9px_-4px_#cbcbcb]",
        dark: "bg-gradient-to-r from-trucare-obsidian to-gridHeader hover:bg-gradient-to-r/90 text-white hover:text-white border border-trucare-obsidian shadow-[0_4px_9px_-4px_#cbcbcb]",
    },
    clear: {
        primary: "text-primary hover:bg-primaryLightColorTwo border border-transparent",
        secondary: "text-secondary hover:bg-primaryLightColor border border-transparent",
        tertiary: "text-gridHeader hover:bg-primaryLightColor border border-transparent",
        info: "text-trucare-azure hover:bg-primaryLightColor border border-transparent",
        success: "text-trucare-teal hover:bg-primaryLightColor border border-transparent",
        warning: "text-trucare-teal hover:bg-trucare-aqua/20 border border-transparent",
        danger: "text-trucare-nocturne hover:bg-primaryLightColorTwo border border-transparent",
        light: "text-trucare-obsidian hover:bg-primaryLightColor border border-transparent",
        dark: "text-trucare-obsidian hover:bg-primaryLightColor border border-transparent",
    },
    link: {
        primary: "text-primary bg-transparent border border-transparent underline",
        secondary: "text-secondary bg-transparent border border-transparent underline",
        tertiary: "text-gridHeader bg-transparent border border-transparent underline",
        info: "text-trucare-azure bg-transparent border border-transparent underline",
        success: "text-trucare-teal bg-transparent border border-transparent underline",
        warning: "text-trucare-teal bg-transparent border border-transparent underline",
        danger: "text-trucare-nocturne bg-transparent border border-transparent underline",
        light: "text-trucare-obsidian bg-transparent border border-transparent underline",
        dark: "text-trucare-obsidian bg-transparent border border-transparent underline",
    }
};

const sizeStyles = {
    small: "px-3 py-1 text-xs",
    medium: "px-4 py-1 text-base",
    large: "px-6 py-2 text-md",
};
const CustomButtonNew = ({
    label,
    variant = "filled",
    prefixIcon,
    size = "medium",
    suffixIcon,
    color = "primary",
    isPill = false,
    fullWidth = false,
    className,
    disabled,
    loading,
    ...inputProps }) => {
    return (
        <button {...inputProps} disabled={disabled || loading} className={`  outline-offset-2 font-normal transition duration-150 ease-in-out ${buttonStyles[variant][color]} ${sizeStyles[size]} ${isPill ? 'rounded-full' : 'rounded-[5px]'} ${fullWidth ? 'w-full' : ''} ${className} disabled:bg-gray-200 disabled:border-gray-200 disabled:cursor-not-allowed disabled:text-gray-400 disabled:from-gray-200 disabled:to-gray-200 disabled:shadow-none disabled:grayscale `}
        >
            {loading ? <Spinner /> : (
                <div className="flex items-center justify-center gap-2 ">
                    {prefixIcon || null}
                    {label ? <span>{label}</span> : null}
                    {suffixIcon || null}
                </div>
            )}

        </button>
    )
}

export default withFeatureSafe(CustomButtonNew);
CustomButtonNew.propTypes = {
    label: PropTypes.string,
    variant: PropTypes.oneOf(['filled', 'outline', 'gradient', 'clear', 'link']),
    prefixIcon: PropTypes.element,
    suffixIcon: PropTypes.element,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'info', 'danger', 'warning', 'dark', 'light']),
    isPill: PropTypes.bool,
    fullWidth: PropTypes.bool,
    className: PropTypes.string,
};